export default __webpack_public_path__ + "static/media/eth.56137ccf.svg";